import { getFileExtension } from '@utils/file-name.util';
import { VIEW_FILES_ALLOWED_EXTENSIONS, VIEW_FILES_MAX_FILE_SIZE_BYTES } from '../properties/view-files-modal.properties';

/** Outcome of validating one selected file. `message` is set only when the file was rejected. */
export interface FileValidationResult {
  readonly isValid: boolean;
  readonly message?: string;
}

const MAX_FILE_SIZE_LABEL = `${Math.round(VIEW_FILES_MAX_FILE_SIZE_BYTES / (1024 * 1024))}MB`;

/**
 * Validates one file against the allowed extensions and the size limit.
 * Applied to every role: the size cap is a platform constraint, not a customer-only rule.
 *
 * @param file - file picked by the user
 */
export function validateFile(file: File): FileValidationResult {
  const extension = getFileExtension(file?.name).toLowerCase();

  if (!extension || !VIEW_FILES_ALLOWED_EXTENSIONS.includes(extension)) {
    return { isValid: false, message: `The file ${file?.name} has an unsupported extension.` };
  }

  if (file.size > VIEW_FILES_MAX_FILE_SIZE_BYTES) {
    return { isValid: false, message: `The file ${file.name} exceeds the ${MAX_FILE_SIZE_LABEL} size limit.` };
  }

  return { isValid: true };
}
